import React from "react";
import { motion } from "framer-motion";
import { Briefcase, ShieldCheck, Layers, Zap, Handshake } from "lucide-react";
import { SectionLabel } from "./Shared";
import { WHY_FEATURES, IMAGES } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

const ICONS = { Briefcase, ShieldCheck, Layers, Zap, Handshake };

export const WhyProspera = () => (
  <section className="bg-[#1F1F1F] text-[#F7F7F5] py-24 md:py-36" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-16">
        <SectionLabel dark>Why Prospera</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight">
          More Than Recruitment. A Better Way to <span className="text-[#E03535]">Build Teams.</span>
        </h2>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid md:grid-cols-3 gap-5 auto-rows-[minmax(180px,auto)]"
      >
        <motion.div
          variants={fadeUp}
          className="md:row-span-2 relative rounded-sm overflow-hidden min-h-[380px]"
          data-testid="why-image"
        >
          <img
            src={IMAGES.employers}
            alt="Prospera Staffing consultants meeting with a corporate client in Dubai"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/30 to-transparent" />
          <div className="absolute bottom-0 p-8">
            <p className="font-display text-2xl leading-snug">
              Recruitment built on trust, insight, and results.
            </p>
          </div>
        </motion.div>

        {WHY_FEATURES.map((f) => {
          const Icon = ICONS[f.icon] || Briefcase;
          return (
            <motion.div
              key={f.title}
              variants={fadeUp}
              data-testid={`why-feature-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group bg-[#151515] border border-white/10 rounded-sm p-7 hover:border-[#C62828]/60 transition-colors duration-400"
            >
              <Icon size={26} strokeWidth={1.5} className="text-[#E03535] mb-5" />
              <h3 className="font-body font-600 text-lg mb-2">{f.title}</h3>
              <p className="font-body text-white/55 text-sm leading-relaxed">{f.desc}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);

export default WhyProspera;
